import {
  DefinitionOfEarningsEnum,
  NotDisclosed,
} from "@platform/openapi-types";

/**
 * Earnings types where the "Average Months" field is not applicable.
 * Used in both the UI definition (to disable the cell) and the API transform (to omit the value).
 */
export const EARNINGS_TYPES_WITHOUT_AVERAGE_MONTHS: string[] = [
  DefinitionOfEarningsEnum.salary,
  DefinitionOfEarningsEnum.priorYearW2,
  DefinitionOfEarningsEnum.k1,
  DefinitionOfEarningsEnum.notApplicable,
  DefinitionOfEarningsEnum.notIncluded,
  NotDisclosed,
];
